import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { connect } from 'react-redux';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  buildSimilarVehiclesCrossShopPath,
  CoreResearchEntities,
  CoreResearchModel,
} from 'client/data/models/core-research';
import { BuildPriceEntities } from 'client/data/models/build-price';
import { buildPopularStylesPath, VehicleEntities, VehicleModel } from 'client/data/models/vehicle-v2';
import { getSubmodelIdentifier } from 'site-modules/shared/utils/core-page/page-helpers';
import { getBuildAndPriceLink } from 'site-modules/shared/utils/build-and-price-link-constructor';

import './related-builds-links.scss';

const LINKS_NUM = 6;

function RelatedBuildsLinksUI({ styles = null, similarVehicles = null, modelYear }) {
  if (!styles && !similarVehicles) {
    return null;
  }

  return (
    <Fragment>
      <h2 className="heading-3 mb-1_5">Related Links</h2>
      <Row className="related-builds-links">
        {!!get(styles, 'length') && (
          <Col xs={12} md={4}>
            <h3 className="category-heading heading-5 mb-0 text-gray-darker">Popular {modelYear.modelName} Builds</h3>
            <ul className="list-unstyled">
              {styles.map(({ makeSlug, modelSlug, year, trim, id, modelName, makeName, submodels }) => (
                <li key={`popular-model-build-${id}`}>
                  <a
                    className="related-link"
                    href={getBuildAndPriceLink(
                      {
                        make: makeSlug,
                        model: modelSlug,
                        modelyearId: modelYear.id,
                        submodel: getSubmodelIdentifier(get(submodels, 'name'), modelName),
                        styleId: id,
                      },
                      true
                    )}
                  >
                    {`Build your ${year} ${makeName} ${modelName} ${trim}`}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        )}
        {!!get(similarVehicles, 'length') && (
          <Col xs={12} md={4}>
            <h3 className="category-heading heading-5 mb-0 text-gray-darker">Similar Builds</h3>
            <ul className="list-unstyled">
              {similarVehicles.map(
                ({ make: { name: makeName, slug: makeSlug }, model: { name: modelName, slug: modelSlug }, year }) => (
                  <li key={`similar-build-${makeSlug}-${modelSlug}-${year}`}>
                    <a
                      className="related-link"
                      href={getBuildAndPriceLink({ make: makeSlug, model: modelSlug, year }, true)}
                    >
                      {`Build your ${year} ${makeName} ${modelName}`}
                    </a>
                  </li>
                )
              )}
            </ul>
          </Col>
        )}
      </Row>
    </Fragment>
  );
}

RelatedBuildsLinksUI.propTypes = {
  modelYear: BuildPriceEntities.ModelYear.isRequired,
  styles: VehicleEntities.PopularStyles,
  similarVehicles: PropTypes.arrayOf(CoreResearchEntities.SimilarVehicleCrossShop),
};

const mapStateToProps = state => ({
  modelLinkCode: get(state, 'pageContext.vehicle.model.modelLinkCode'),
});

export const RelatedBuildsLinks = connect(mapStateToProps)(
  connectToModel(RelatedBuildsLinksUI, {
    styles: bindToPath(
      ({ modelYear: { makeSlug, modelSlug, year } }) =>
        buildPopularStylesPath({ make: makeSlug, model: modelSlug, year }),
      VehicleModel,
      styles => styles.slice(0, LINKS_NUM)
    ),
    similarVehicles: bindToPath(
      ({ modelLinkCode }) => buildSimilarVehiclesCrossShopPath(modelLinkCode, LINKS_NUM),
      CoreResearchModel
    ),
  })
);
